import axios from "axios";
import { useEffect, useState } from "react";

interface DepositItem {
  uid: string;
  transaction_id: number;
  payment_type: string;
  payment_method?: string;
  transaction_date: string;
  name: string;
  amount: number;
  status: string;
  utr_no: string;
}

const ManualDeposit = () => {
  const [mode, setMode] = useState("manual"); // To toggle between manual and online payments
  const [isManualPayment, setIsManualPayment] = useState(true); // To toggle between manual and online payments
  const [depositData, setDepositData] = useState<DepositItem[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTerm2, setSearchTerm2] = useState("");

  const [page, setPage] = useState(1);
  const [limit] = useState(10); // or make it dynamic if needed
  const [totalPages, setTotalPages] = useState(1);


  useEffect(() => {
    fetchDepositData(page, limit);
  }, [mode, page]); // Re-fetch data when payment type changes

  const filteredDeposits = depositData.filter((deposit) =>
    [deposit.name, deposit.uid, deposit.utr_no].some((field) =>
      field?.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );
  const filteredDeposits2 = depositData.filter((deposit) =>
    [deposit.name, deposit.uid, deposit.utr_no].some((field) =>
      field?.toString().toLowerCase().includes(searchTerm2.toLowerCase())
    )
  );

  // Fetch data from the API based on transaction type
  const fetchDepositData = async (page = 1, limit = 10) => {
    try {
      const transactionType = mode === "manual" ? "manual" : "online"; // Set transaction type based on state
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL_API}/getManualDepositData?page=${page}&limit=${limit}`,
        {
          params: { transactionType },
        }
      );
      const data = response?.data?.data;
      setTotalPages(response?.data?.totalPages || 1); // Set total pages from response
      setPage(response?.data?.currentPage || 1); // Set current page from response
      // Check if data is an array


      if (Array.isArray(data)) {
        const reversedData = data.reverse(); // Optionally reverse data for most recent first
        setDepositData(reversedData);
      } else {
        console.error("Unexpected response structure:", data);
        setDepositData([]);
      }
    } catch (error) {
      console.error("Failed to fetch deposit data:", error);
      setDepositData([]);
    }
  };

  const handleManualPaymentToggle = () => {
    setIsManualPayment(true);
  };

  const handleOnlinePaymentToggle = () => {
    setIsManualPayment(false);
  };

  const handleAcceptPayment = async (
    transactionId: number,
    utrNo: string,
    uid: string,
    amount: number,
    coin: string,
    payment_type: string
  ) => {
    // Call the API to approve the payment
    await approveOrRejectManualDeposit(utrNo, uid, coin, amount, true, payment_type);
    console.log(`Accepted payment for transaction ID: ${transactionId}`);
  };

  const handleRejectPayment = async (
    transactionId: number,
    utrNo: string,
    uid: string,
    amount: number,
    coin: string,
    payment_type: string
  ) => {
    // Call the API to reject the payment
    await approveOrRejectManualDeposit(utrNo, uid, coin, amount, false, payment_type);
    console.log(`Rejected payment for transaction ID: ${transactionId}`);
  };

  const approveOrRejectManualDeposit = async (
    utr_no: string,
    uid: string,
    coin: string,
    amount: number,
    isApproved: boolean,
    payment_type: string
  ) => {
    try {
      await axios.post(`${process.env.REACT_APP_BASE_URL_API}/approveRejectManualDeposit`, {
        utr_no,
        uid,
        coin,
        amount,
        isApproved,
        payment_type, // Include payment type in the request
      });
      // Optionally refresh deposit data after processing
      fetchDepositData();
    } catch (error) {
      console.error("Error processing manual deposit:", error);
    }
  };

  const handleModeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMode(event.target.value);
  };

  return (
    <div className="ml-0 lg:ml-[256px] ">
      <div className="flex justify-center bg-[#ffffff] mt-4 p-4">
        <div className="flex flex-wrap bg-[#F9FAFB] p-1 rounded-lg shadow-sm w-34 sm:w-72 text-sm">
          <label className="flex-1 text-center cursor-pointer">
            <input
              type="radio"
              name="mode"
              value="manual"
              className="hidden"
              checked={mode === "manual"}
              onChange={handleModeChange}
            />
            <span
              className={`whitespace-nowrap text-black flex items-center justify-center p-2 rounded-lg transition-all duration-150 ease-in-out font-semibold ${mode === "manual"
                  ? "bg-[#228BE6] text-white"
                  : ""
                }`}
            >
              Manual
            </span>
          </label>
          <label className="flex-1 text-center cursor-pointer">
            <input
              type="radio"
              name="mode"
              value="automatic"
              className="hidden"
              checked={mode === "automatic"}
              onChange={handleModeChange}
            />
            <span
              className={`whitespace-nowrap text-black flex items-center justify-center p-2 rounded-lg transition-all duration-150 ease-in-out font-semibold ${mode === "automatic"
                  ? "bg-[#228BE6] text-white"
                  : ""
                }`}
            >
              Automatic
            </span>
          </label>
        </div>
      </div>

      {mode === "manual" ? (
        <>
          <div className="flex items-center justify-between p-4 bg-[#ffffff] dark:bg-[#ffffff] rounded-t-lg">
            <h2 className="text-xl font-bold text-black">
              Manual Payment Details
            </h2>
            <div className=" flex justify-end items-center">
              <label htmlFor="search" className="sr-only">
                Search
              </label>
              <div className="">
                <input
                  type="text"
                  id="search"
                  className="bg-[#ffffff] w-full pl-10 pr-4 py-2 rounded-lg border  shadow-sm focus:outline-none text-black"
                  placeholder="Search by name or UID"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg
                    className="h-5 w-5 text-gray-500"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div className="overflow-x-auto custom-scrollbar  shadow-md sm:rounded-lg bg-white">
            <table className="w-full text-sm text-left text-gray-500">
              <thead className="text-xs text-white uppercase bg-[#394a6a]">
                <tr>
                  <th className="py-3 px-6">SNo.</th>
                  <th className="py-3 px-6">User Name</th>
                  <th className="py-3 px-6">Amount</th>
                  <th className="py-3 px-6">Payment Method</th>
                  <th className="py-3 px-6">UTR No</th>
                  <th className="py-3 px-6">Status</th>
                  <th className="py-3 px-6">Date</th>
                  <th className="py-3 px-6">Actions</th>
                </tr>
              </thead>
              <tbody className="text-center">
                {filteredDeposits.map((deposit, index) => (
                  <tr
                    key={deposit.transaction_id}
                    className="group bg-[#F9FAFB] border-b border-gray-200 "
                  >
                    <td className="text-black py-4 px-6">{index + 1}</td>
                    <td className="text-black py-4 px-6">{deposit.name}</td>
                    <td className="text-black py-4 px-6">
                      {deposit?.payment_type == "usdt" ? "$" : "৳ "}{deposit.amount.toFixed(1)}
                    </td>
                    <td className="text-black py-4 px-6 capitalize">
                      {deposit?.payment_method || deposit?.payment_type || 'N/A'}
                    </td>
                    <td className="text-black py-4 px-6">{deposit.utr_no}</td>
                    <td
                      className={`py-4 px-6 capitalize ${deposit.status.toLowerCase() === "accepted"
                          ? "text-green-500"
                          : deposit.status.toLowerCase() === "rejected"
                            ? "text-red-500"
                            : "text-yellow-500"
                        }`}
                    >
                      {deposit.status}
                    </td>

                    <td className="text-black py-4 px-6 whitespace-nowrap">
                      {new Date(deposit.transaction_date).toLocaleString()}
                    </td>
                    <td className="text-black py-4 px-6">
                      {deposit.status === "pending" ? (
                        <div style={{ display: "flex", gap: "10px" }}>
                          <button
                            className="px-3 py-1 mr-2 bg-[#228BE6] text-white rounded"
                            onClick={() =>
                              handleAcceptPayment(
                                deposit.transaction_id,
                                deposit.utr_no,
                                deposit.uid,
                                deposit.amount,
                                "inr",
                                deposit?.payment_type
                              )
                            }
                          >
                            Accept
                          </button>
                          <button
                            className="px-3 py-1 bg-red-500 text-white rounded"
                            onClick={() =>
                              handleRejectPayment(
                                deposit.transaction_id,
                                deposit.utr_no,
                                deposit.uid,
                                deposit.amount,
                                "inr",
                                deposit?.payment_type
                              )
                            }
                          >
                            Reject
                          </button>
                        </div>
                      ) : null}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={16} className="py-4 px-6 text-start">
                    <nav className="inline-flex items-center space-x-2">
                      <button
                        onClick={() => fetchDepositData(page - 1, limit)}
                        disabled={page <= 1}
                        className={`px-4 py-2 rounded ${page <= 1
                            ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                            : "bg-blue-500 text-white hover:bg-blue-600"
                          }`}
                      >
                        Previous
                      </button>
                      <span className="text-gray-700 px-4 py-2">Page {page} of {totalPages}</span>
                      <button
                        onClick={() => fetchDepositData(page + 1, limit)}
                        disabled={page >= totalPages}
                        className={`px-4 py-2 rounded ${page >= totalPages
                            ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                            : "bg-blue-500 text-white hover:bg-blue-600"
                          }`}
                      >
                        Next
                      </button>
                    </nav>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </>
      ) : (
        <>
          <div className="flex items-center justify-between p-4 bg-[#ffffff] dark:bg-[#ffffff] rounded-t-lg">
            <h2 className="text-xl font-bold text-black">
              Automatic Payment Details
            </h2>
            <div className=" flex justify-end items-center">
              <label htmlFor="search" className="sr-only">
                Search
              </label>
              <div className="">
                <input
                  type="text"
                  id="search"
                  className="bg-[#ffffff] w-full pl-10 pr-4 py-2 rounded-lg border  shadow-sm focus:outline-none text-black"
                  placeholder="Search by name or UID"
                  value={searchTerm2}
                  onChange={(e) => setSearchTerm2(e.target.value)}
                />
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg
                    className="h-5 w-5 text-gray-500"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div className="overflow-x-auto custom-scrollbar  shadow-md sm:rounded-lg bg-[#101828]">
            <table className="w-full text-sm text-left text-gray-500">
              <thead className="text-xs text-white uppercase bg-[#394a6a]">
                <tr>
                  <th className="py-3 px-6">SNo.</th>
                  <th className="py-3 px-6">User Name</th>
                  <th className="py-3 px-6">Amount</th>
                  <th className="py-3 px-6">Payment Method</th>
                  <th className="py-3 px-6">UTR No</th>
                  <th className="py-3 px-6">Status</th>
                  <th className="py-3 px-6">Date</th>
                  <th className="py-3 px-6">Actions</th>
                </tr>
              </thead>
              <tbody className="text-center">
                {filteredDeposits2.map((deposit, index) => (
                  <tr
                    key={deposit.transaction_id}
                    className="group bg-[#F9FAFB] border-b border-gray-200 "
                  >
                    <td className="text-black py-4 px-6">{index + 1}</td>
                    <td className="text-black py-4 px-6">{deposit.name}</td>
                    <td className="text-black py-4 px-6">
                      ৳{deposit.amount.toFixed(1)}
                    </td>
                    <td className="text-black py-4 px-6 capitalize">
                      {deposit?.payment_method || deposit?.payment_type || 'N/A'}
                    </td>
                    <td className="text-black py-4 px-6">{deposit.utr_no}</td>
                    <td
                      className={`py-4 px-6 capitalize ${deposit.status.toLowerCase() === "accepted"
                          ? "text-green-500"
                          : deposit.status.toLowerCase() === "rejected"
                            ? "text-red-500"
                            : "text-yellow-500"
                        }`}
                    >
                      {deposit.status}
                    </td>
                    <td className="text-black py-4 px-6">
                      {new Date(deposit.transaction_date).toLocaleString()}
                    </td>
                    <td className="py-4 px-6">
                      {deposit.status === "pending" ? (
                        <>
                          <button
                            className="px-3 py-1 bg-yellow-500 text-white rounded"
                          // onClick={() => handleRejectPayment(deposit.transaction_id, deposit.utr_no, deposit.uid, deposit.amount, 'inr')}
                          >
                            Pending
                          </button>
                        </>
                      ) : deposit.status === "accepted" ? (
                        <button className="px-3 py-1 mr-2 bg-[#228BE6] text-white rounded">
                          Success
                        </button>
                      ) : (
                        <button className="px-3 py-1 mr-2 bg-red-500 text-white rounded">
                          Rejected
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="bg-[#F9FAFB]">
                <tr>
                  <td colSpan={16} className="py-4 px-6 text-start">
                    <nav className="inline-flex items-center space-x-2">
                      <button
                        onClick={() => fetchDepositData(page - 1, limit)}
                        disabled={page <= 1}
                        className={`px-4 py-2 rounded ${page <= 1
                            ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                            : "bg-blue-500 text-white hover:bg-blue-600"
                          }`}
                      >
                        Previous
                      </button>
                      <span className="text-gray-700 px-4 py-2">Page {page} of {totalPages}</span>
                      <button
                        onClick={() => fetchDepositData(page + 1, limit)}
                        disabled={page >= totalPages}
                        className={`px-4 py-2 rounded ${page >= totalPages
                            ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                            : "bg-blue-500 text-white hover:bg-blue-600"
                          }`}
                      >
                        Next
                      </button>
                    </nav>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default ManualDeposit;
